export default __webpack_public_path__ + "static/media/aboutbg.e881692b.jpeg";